VP = window.VP || {};

(function ($) {
	VP.featuredModule = {
		init: function () {
			var _this = this;
			_this.eventHandlers();
		},

		eventHandlers: function () {
			var _this = this;
			$(window).scroll(function () {
				_this.contentOpacityHandler();
			});
		},

		contentOpacityHandler: function () {
			var currentScroll = window.pageYOffset;
			var $hero = $('.vp-module__featured-hero');
			var opacityStart = -100;
			var opacityEnd = $hero.outerHeight() * 0.3;
			if (currentScroll > opacityStart) {
				var opacity = opacityEnd - currentScroll;
				opacity = (opacity > 0 ? opacity : 0) / opacityEnd;
				$hero.find('.vp-featured-hero').css('opacity', opacity);
			}

            // hide the hero on scroll down causes blurry image on scroll up, doesn't transition properly
			if (currentScroll + 100 > ($hero.outerHeight() + 300) && !$hero.hasClass('hide')) {
					$hero.addClass('hide');
			} else if (currentScroll <= ($hero.outerHeight() + 300) && $hero.hasClass('hide')) {
					$hero.removeClass('hide');
			}
		},
	};
})(jQuery);
